export enum SortDirection {
	None = 'None',
	Asc = 'Asc',
	Desc = 'Desc'
}